module.exports = __webpack_public_path__ + "static/media/VOCAB-04.e31c5e08.png";